import {Mic, MicOff, Pause, Play, PhoneOff} from "lucide-react";
import {useEffect, useRef, useState} from "react";
import {Button} from "./Button";

const AUDIO_URL =
  "https://storage.googleapis.com/storage-synthflow-develop/1722531305903x902380921881624600/REe90c4d84bdacbf099a79a73403cab419.wav?Expires=4907401549&GoogleAccessId=livekit-egress%40synthflow-dev.iam.gserviceaccount.com&Signature=EM%2FBYRVudYJ9EhcJBq07ZjKETRc64DxDxs9GeAn6cI4ozkXR02yoTv%2FWZPPhbvrvngqPdJwrDKbKcVO921Vn4U8nmYlSaElDg5%2BG33BxlZfkjf5m%2FfstYyXw0FeQ3cOwtmIO4zTkn1F%2B9lJtordzDbHGokjLh%2FfXI%2BbQJppHM5g5kwb3mPeR0Vek8cAHjb%2FDT%2F8hIP7k%2BLxj%2B%2FDwwn6WzCl8BoVl4Og53kR28OzU7mmhVYfzbnqIHTu%2FYvPpAmMHABobUevzAxb08op5d2Df3f9mTtYZZeK5WmIBAcU7U%2BJBw3W6XVNHpo%2Btg2JgHAh%2Bf3ltXT78kWEa0wDD1EJvOw%3D%3D";

const formatTime = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
};

const CallPlayer = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMicOn, setIsMicOn] = useState(true);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    const audio = new Audio(AUDIO_URL);
    audio.preload = "auto";
    audioRef.current = audio;

    const handleTimeUpdate = () => {
      setElapsedSeconds(audio.currentTime || 0);
    };
    const handleEnded = () => {
      setIsPlaying(false);
    };

    audio.addEventListener("timeupdate", handleTimeUpdate);
    audio.addEventListener("ended", handleEnded);

    return () => {
      audio.pause();
      audio.removeEventListener("timeupdate", handleTimeUpdate);
      audio.removeEventListener("ended", handleEnded);
      audioRef.current = null;
    };
  }, []);

  const togglePlayPause = async () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      try {
        await audio.play();
        setIsPlaying(true);
      } catch {
        // Ignore autoplay restrictions errors
      }
    }
  };

  const handleEndTest = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
    setIsPlaying(false);
    setElapsedSeconds(0);
  };

  const toggleMicIcon = () => {
    setIsMicOn(prev => !prev);
  };

  return (
    <div className="flex px-4 py-5 gap-4 bg-slate-800 rounded-xl items-center">
      <div className="flex flex-col">
        <div className="text-base font-semibold text-inverse">Live Test</div>
        <div className="text-sm text-disabled">
          {formatTime(elapsedSeconds)}
        </div>
      </div>
      <div className="flex ml-auto gap-2">
        <Button
          variant="outline-inverse"
          className="[&_svg]:size-4.5"
          size="icon-button"
          onClick={toggleMicIcon}
        >
          {isMicOn ? (
            <Mic className="text-inverse" />
          ) : (
            <MicOff className="text-inverse" />
          )}
        </Button>
        <Button
          variant="outline-inverse"
          className="[&_svg]:size-4.5"
          size="icon-button"
          onClick={togglePlayPause}
        >
          {isPlaying ? (
            <Pause className="text-inverse" />
          ) : (
            <Play className="text-inverse" />
          )}
        </Button>
        <Button variant="destructive" size="sm" onClick={handleEndTest}>
          <PhoneOff /> End Test
        </Button>
      </div>
    </div>
  );
};

export default CallPlayer;
